import React from "react";
import { GiClover } from "react-icons/gi";
import { useState, useEffect, useContext } from "react";
import { DEFAULT_COLOR } from "../lib/constants";
import AppContext from "../context/AppProvider";
import App from "../App";

const CalendarBlock = ({ id, day, blockColor, handleDayClick }) => {
  const { settings } = useContext(AppContext);

  const [buttonColor, setButtonColor] = useState("white");

  // Code for thicker border for current day
  let date = new Date();
  let today = date.getDate();

  const style = {
    backgroundColor: blockColor,
    borderColor: "",
    width: "10%",
    border:
      today == day
        ? `4px solid ${settings.color}`
        : `1px solid ${settings.color}`,
    borderRadius: "10px",
    justifyContent: "space-around",
    alignItems: "center",
    margin: "2%",
    padding: "0%",
  };
  const pStyle = {
    fontSize: "1rem",
    color:
      blockColor === "white"
        ? "black"
        : day.color === "#FF7BA9"
        ? "white"
        : "white",
    margin: "auto",
    padding: "10%",
  };

  return (
    <button style={style} onClick={() => handleDayClick(id, day)}>
      {/* <p style={pStyle}>{new Date().toDateString().split(' ').slice(1,3)}</p> */}
      <p style={pStyle}>{day}</p>
    </button>
  );
};

export default CalendarBlock;
